import "core-js/stable";
import * as React from "react";
import * as ReactDOM from "react-dom";
import "regenerator-runtime/runtime";

import "../../resources/assets/styles/base.scss";
import { App } from "./components/App";

// Hot Module Replacement API
declare let module: {
    hot: any;
};

const rootEl = document.getElementById("root");

ReactDOM.render(<App/>, rootEl);

if (module.hot) {
    module.hot.accept(() => {
        ReactDOM.render(<App/>, rootEl);
    });
}
